export default __webpack_public_path__ + "static/media/cert.9592d133.svg";